import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './styles.css';

const dataMode = import.meta.env.VITE_DATA_MODE ?? 'synthetic-only';
if (dataMode !== 'synthetic-only') {
  throw new Error('Release 3.0 scaffold permits synthetic-only data mode');
}

const root = document.getElementById('root');
if (!root) throw new Error('Portal root element is missing');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
